<template>
  <div class="layer_section-container">
    <div class="layer-header">
      <h1 class="header-title">주문불가 제품 알림</h1>
      <button type="button" class="btn-modal_close" @click="onDispose">
        닫기
      </button>
    </div>
    <div class="layer-content">
      <div class="cart-popup__item-info">
        <div class="pop-prot-body">
          <div
            class="cannot-order-list"
            v-for="product in soldoutProducts"
            :key="product.item_sku"
          >
            <div class="cartlist-image">
              <img
                :src="product.img_url"
                class="no-border-image"
                alt="pro-duct3"
              />
            </div>
            <div class="cartlist-text">
              <div class="cart-popup__item-head">
                <div class="cartlist-title">
                  {{ product.item_name }}
                  <div class="cartlist-small2">{{ product.item_sku }}</div>
                </div>
                <div class="cartlist-quantity">
                  <span class="qua-tite">주문수량</span>
                  <span class="qua-num">
                    <template v-if="isDoubleX(product.item_sku)"
                      >{{ product.count * 3 }}{{ product.display }} ({{
                        product.count
                      }}세트)</template
                    >
                    <template v-else
                      >{{ product.count }}{{ product.display }}</template
                    >
                  </span>
                </div>
              </div>
              <div class="cart-popup__item-com">
                <div class="com-ttile">주문불가 사유</div>
                <p class="com-txt">
                  [{{ product.item_name }}({{ product.item_sku }})]은
                  {{ product.status == "endOfSale" ? "단종" : "일시 품절" }}
                  상품 입니다.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="pop-prot-form">
          <div class="form-group" v-if="reOrderble && calcResult.success">
            <input
              class="amwa-radio"
              type="radio"
              name="impossible"
              id="impossible1"
              v-model="selectedAction"
              value="removeAndProceed"
            />
            <label for="impossible1">주문 불가 상품 삭제 후 주문 진행</label>
          </div>
          <div class="form-group">
            <input
              class="amwa-radio"
              type="radio"
              name="impossible"
              id="impossible2"
              v-model="selectedAction"
              value="cancelPack"
            />
            <label for="impossible2">주문 취소</label>
          </div>
          <template v-if="fetchCalc">
            <p
              class="info_desc"
              v-if="
                purchaseType == 'recurring' && curSeq >= 2 && calcResult.success
              "
            >
              * 주문 취소를 선택한 경우, 일시품절시에는 해당 회차만 취소되지만
              단종 제품이 포함되어 있는 경우에는 전체 회차가 취소됩니다.
            </p>
            <p
              class="info_desc"
              v-if="
                purchaseType == 'recurring' &&
                curSeq >= 2 &&
                !calcResult.success
              "
            >
              * 단종 또는 품절된 제품에 의해 마이팩의 함량이 유효하지 않아
              주문이 불가합니다.<br />
              * 주문 취소를 선택한 경우, 일시품절시에는 해당 회차만 취소되지만
              단종 제품이 포함되어 있는 경우에는 전체 회차가 취소됩니다.
            </p>
            <p
              class="info_desc"
              v-if="
                !(purchaseType == 'recurring' && curSeq >= 2) &&
                calcResult.success
              "
            >
              * 단종 또는 품절된 제품에 의해 동일한 제품으로는 주문이
              불가합니다.
            </p>
            <p
              class="info_desc"
              v-if="
                !(purchaseType == 'recurring' && curSeq >= 2) &&
                !calcResult.success
              "
            >
              * 단종 또는 품절된 제품에 의해 마이팩의 함량이 유효하지 않아
              주문이 불가합니다
            </p>
          </template>
        </div>
      </div>
    </div>
    <div class="align-box size-auto">
      <button
        type="button"
        class="btn-modal_close btn-modal_confirm"
        @click="onDispose"
      >
        취소
      </button>
      <button type="button" class="btn-modal_close v2" @click="confirm">
        확인
      </button>
    </div>
    <modal-alert ref="refAlert" />
    <modal-confirm ref="refConfirm" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import productApi from "@/apis/product";
import doubleXMixin from "@/components/global/doublex-mixin";
import ModalAlert from "@/components/global/ModalAlert.vue";
import ModalConfirm from "@/components/global/ModalConfirm.vue";
import ProductsItemInfoDetail from "@/components/modal-popups/PopupProductsItemInfoDetail.vue";
import Template from "@/views/Template.vue";

export default {
  name: "PopupUnavailableProducts",
  mixins: [doubleXMixin],
  components: {
    ModalAlert,
    ModalConfirm,
    ProductsItemInfoDetail,
    Template,
  },
  props: {
    purchaseType: {
      type: String,
      default: "",
    },
    curSeq: {
      type: Number,
      default: 0,
    },
    soldoutProducts: {
      type: Array,
      default: () => [],
    },
    reOrderble: {
      type: Boolean,
      default: true,
    },
    reCalDoseInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      calcResult: {
        success: null,
        results: {
          lack: [],
          over: [],
        },
      },
      selectedAction: "",
      fetchCalc: false,
    };
  },
  computed: {
    ...mapGetters({
      rawProducts: "product/products",
      context: "context/context",
    }),
  },
  mounted() {
    this.calc();
  },
  methods: {
    onDispose() {
      this.$emit("dispose", "get out!");
    },
    async confirm() {
      if (!this.selectedAction) {
        this.$refs.refAlert.openWithMessage("옵션을 선택해 주세요.");
        return;
      }
      if (this.selectedAction == "removeAndProceed") {
        this.$emit("remove-and-proceed");
      } else if (this.selectedAction == "cancelPack") {
        this.$emit("cancel-pack");
      }
    },
    async calc() {
      const concatenated = this.reCalDoseInfo;
      try {
        const calcResult = await productApi.getIngridientCalculationResult(
          concatenated
        );
        this.calcResult.results.lack = this.mapProductsBySku(calcResult.lack);
        this.calcResult.results.over = this.mapProductsBySku(calcResult.over);
        this.calcResult.success =
          calcResult.over.length === 0 && calcResult.lack.length === 0;

        this.fetchCalc = true;
      } catch (e) {
        console.error(e);
      }
    },
    mapProductsBySku(arr) {
      return arr.map((n) => ({
        ingredientsName: n.ingredients_name,
        items: ((skus) =>
          skus.map((sku) => ({
            itemSku: sku,
            itemName: this.rawProducts.find((p) => p.item_sku === sku)
              .item_name,
          })))(n.item_sku),
      }));
    },
  },
};
</script>

<style>
</style>